module.exports = __webpack_public_path__ + "static/media/teltonika-fmb900-micro-sd-card-and-bluetooth-v3-0-12.e19f7cbb.jpg";